import { RESETPENGADAAN, SETPENGADAAN, SETFILEBYID, RESETFILEBYID } from "./pengadaanTypes";

const initialState = {
    data: [],
    fileById: null
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SETPENGADAAN:
            return {
                ...state,
                ...payload
            };
        case RESETPENGADAAN:
            return {
                ...state,
                data: []
            };
        case SETFILEBYID:
            return{
                ...state,
                fileById: payload
            };
        case RESETFILEBYID:
            return{
                ...state,
                fileById: payload
            };
        default:
            return state;
    }
}

export default reducer;